/**
 * We want to load filestack-react in a separate webpack chunk, but webpack does not
 * recognize React.lazy in dependencies. Thus, we need the app
 * code to do the dynamic import and pass in into this provider
 */

import React, { useContext } from "react";

export type FilestackContextProps = {
  ReactFilestack: React.ComponentType<any>;
};

const FilestackContext = React.createContext<FilestackContextProps | undefined>(
  undefined
);

export function FilestackProvider({
  children,
  ReactFilestack,
}: {
  children: React.ReactNode;
  ReactFilestack: React.FC;
}) {
  return (
    <FilestackContext.Provider value={{ ReactFilestack }}>
      {children}
    </FilestackContext.Provider>
  );
}

export const useFilestackComponent = () => {
  const context = useContext(FilestackContext);

  if (!context) {
    throw new Error("FilestackProvider is missing from the component tree");
  }

  return context;
};
